import React from "react";

import Tr from "./Tr"; // Importing the row component for each table entry

// Functional component to render a table with provided data
export default function Table({ data, onEdit, onDelete, isAllowedToEditOrDelete }) {
  return (
    <div className="form-container">
      <table className="table">
        <thead>
          <tr>
            {/* Table header with column titles */}
            <th className="col-numeric-date">Order</th>
            <th className="col-numeric-date">Rank</th>
            <th className="col-numeric-date">Color</th>
            <th className="col-options">Options</th>
          </tr>
        </thead>

        <tbody>
          {/* Check if there's any data to display */}
          {data.length === 0 ? (
            // If no data, display a message
            <tr>
              <td colSpan={4}>No data found....</td>
            </tr>
          ) : (
            // Map through the data and render each row using the Tr component
            data.map((d, index) => (
              <Tr
                key={index} // Unique key for each row
                id={d.background_id} // ID of the background color
                order={index} // Order of the item based on its index
                rank={d.rank} // Rank from the data
                color_hex_code={d.color_hex_code} // Color hex code from the data
                onEdit={onEdit} // Function to handle editing
                onDelete={onDelete} // Function to handle deletion
                isAllowedToEditOrDelete={isAllowedToEditOrDelete} // Permission flag for editing/deleting
              />
            ))
          )}
        </tbody>
      </table>
    </div>
  );
}
